export { default } from './TooltipHost';
